import {
  ajax
} from 'application/src/js/functions.js';
import {
  Mediator
} from 'application/src/js/util';

/**
 * @description modal for quickly changing certain offer settings
 * @param {ModalWindow} args.modal ModalWindow instance
 * @param {SpinnerOverlay} args.loader SpinnerOverlay instance
 */
export default class OfferSettingsModal extends Mediator {
  constructor(args) {
    super(args);
    this.modal = args.modal;
    this.loader = args.loader;

    this.saveButton = this.modal.element.querySelectorAll('.button-save');
    this.openButton = document.querySelectorAll('.button-show-offer-settings-modal');
    this.highlightingTypeSelect = document.querySelector('#highlighting-type-setting');

    this.requestOfferId = null;
    this.debugMode = true;
    this.offerId = this.modal.element.getAttribute('data-offer-id');
    this.offerType = this.modal.element.getAttribute('data-offer-type');

    this.addEvents();
  }

  addEvents() {
    [...this.openButton].map(button => {
      button.addEventListener('click', e => this.modal.open());
    });

    [...this.saveButton].map(button => {
      button.addEventListener('click', _ => this.save());
    });
  }

  save() {
    this.loader.show();

    ajax('/mundus-agri/offer/ajaxSetHighlighting', {
      offer_type: this.offerType,
      offer_id: this.offerId,
      highlighting_type: this.highlightingTypeSelect.value,
    }).then(response => {
      this.modal.close();
      this.loader.hide();
      this.publish('saved', {
        highlighting_type: this.highlightingTypeSelect.value
      });
    }).catch(e => {
      if (this.debugMode) console.log(e);
      this.loader.hide();
    });
  }
}